import '~/js/sections/weddings/includes/scroll-below';
import CustomDatePicker from '~/js/components/form-controls/CustomDatePicker';
import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';

ReactDOM.render(
  <CustomDatePicker
    name="arrivalDate"
    inputClassName="checkin-date-input"
    wrapperClassName="col-xs-12 col-lg-7"
    isRequired
    displayPlaceHolder
    displayStringDate={false}
  />,
  document.getElementById('arrival-date-picker-validate'),
);

ReactDOM.render(
  <CustomRecaptcha
    wrapperClassName="xs-12 lg-12"
  />,
  document.getElementById('google-recaptcha')
);

const $bookingNumber = $('#bookingNumberValidate');
const $arrivalDate = $('#arrival-date-picker-validate');
const $resort = $('#resortCodeValidate');
const $lastName = $('#lastNameValidate');
const $errorMsg = $('#general-error');
const $email = $('#email');
const $party = $('#partyValidate');
const errors = [];

const validateBookingBtn = document.getElementById('validate-booking');
const $arrivalDateHidden = $('input[name="arrivalDate"]');

validateBookingBtn.addEventListener('click', e => {
  // $('#arrivaldate').val($arrivalDateHidden);

  if ($bookingNumber.val() === '') {
    //$bookingNumber.addClass('has-error');
    errors.push('booking Number');
  } else {
    $bookingNumber.removeClass('has-error');
  }
  if ($arrivalDateHidden.val() === '') {
    //$arrivalDate.find('.datepicker-text').addClass('has-error');
    errors.push('arrival Date');
  } else {
    $arrivalDate.find('.datepicker-text').removeClass('has-error');
  }
  if ($resort.val() === '') {
    //$resort.addClass('has-error');
    errors.push('resort');
  } else {
    $resort.removeClass('has-error');
  }
  if ($email.val() === '') {
    //$email.addClass('has-error');
    errors.push('email');
  } else {
    $email.removeClass('has-error');
  }
  if ($party.val() === '') {
    //$party.addClass('has-error');
    errors.push('party');
  } else {
    $party.removeClass('has-error');
  }
  if ($lastName.val() === '') {
    //$lastName.addClass('has-error');
    errors.push('last name');
  } else {
    $lastName.removeClass('has-error');
  }

  if (errors.length > 0) {
    $errorMsg.html('Please fill all the fields above');

    return false;
  }
});

// Form validations
import '~/js/modules/fend';

const $autismallinclusiveForm = $('.rsvp-autism-form');

$autismallinclusiveForm.fend({
  rules: {
    firstName: 'lettersOnly',
    lastName: 'lettersOnly',
    bookingNumber: 'alphanumeric',
    sandalsSelectNumber: 'number',
    // arrivalDate: 'date',
  },
  isMultiPart: true
});
